import React, { useState } from "react";
import { Badge, Button, Card, Flex, Text } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";

import { useGetEatAppStatus } from "hooks";
import { EatAppMark } from "./EatAppMark";
import { EatAppSetupDialog } from "./EatAppSetupPage";
import { PermissionAlertDialog } from "components";

export function BrowseEatAppCard({ userProfile }) {
  const navigate = useNavigate();
  const [setupOpen, setSetupOpen] = useState(false);
  const [permissionOpen, setPermissionOpen] = useState(false);
  const { data } = useGetEatAppStatus(userProfile?.organisation_id);
  const active = data?.data?.is_active === true;

  const handleConnect = () => {
    if (userProfile?.user_role === "Owner") setSetupOpen(true);
    else setPermissionOpen(true);
  };

  return (
    <>
    <Card style={{ display: "flex", width: "100%", minWidth: 0, padding: "var(--space-4)", justifyContent: "space-between", alignItems: "center", gap: "var(--space-3)", overflow: "hidden" }}>
      <Flex align="center" gap="4" style={{ minWidth: 0, flex: "1 1 auto" }}>
        <EatAppMark />
        <Flex direction="column" style={{ minWidth: 0 }}>
          <Text size="4" weight="medium" truncate>Eat App</Text>
          <Text size="1" color="gray" truncate>Restaurant guest CRM</Text>
        </Flex>
      </Flex>
      {active ? (
        <Badge size="1" variant="soft" color="green" style={{ flexShrink: 0 }}>Connected</Badge>
      ) : (
        <Button size="2" variant="soft" color="gray" style={{ flexShrink: 0 }} onClick={handleConnect}>
          Connect
        </Button>
      )}
    </Card>
    <EatAppSetupDialog
      isOpen={setupOpen}
      onOpenChange={setSetupOpen}
      onConnected={() => navigate("/integrations")}
    />
    <PermissionAlertDialog
      isOpen={permissionOpen}
      onOpenChange={setPermissionOpen}
      message="Only owners can perform this action"
    />
    </>
  );
}
